import { combineReducers } from 'redux';

import countries from '@reducers/countries';
import entities from '@reducers/entities';
import filingStatus from '@reducers/filingStatus';
import filingTypes from '@reducers/filingTypes';
import gameChanger from '@reducers/gameChanger';
import helpHero from '@reducers/helpHero';
import notes from '@reducers/notes';
import org from '@reducers/organization';
import period from '@reducers/period';
import savedFilingPeriod from '@reducers/savedFilingPeriod';
import standardTemplates from '@reducers/standardTemplate';
import submission from '@reducers/submission';
import taxCodes from '@reducers/taxCodes';
import transactionTypes from '@reducers/transactionTypes';
import upload from '@reducers/upload';
import user from '@reducers/user';
import vatNumbers from '@reducers/vatNumbers';
import vatReturn from '@reducers/vatReturn';
import apiSettings from '@store/apiSettings';
import appNotifications from '@store/appNotifications/appNotifications.reducer';
import auth from '@store/auth';
import conversionTool from '@store/conversionTool/conversionTool.reducer';
import dashboard from '@store/dashboard/dashboard.reducer';
import dataFormats from '@store/dataFormats';
import entityJurisdictions from '@store/entityJurisdictions/entityJurisdictions.reducer';
import filing from '@store/filing/filing.reducer';
import filingList from '@store/filingList';
import inviteUser from '@store/inviteUser/inviteUser.reducer';
import jurisdictions from '@store/jurisdictions';
import manageUsers from '@store/manageUsers';
import messages from '@store/messages/messages.reducer';
import polishSku from '@store/polishSku';
import reducedRates from '@store/reducedRates';
import registrations from '@store/registrations/registrations.reducer';
import troubleshooting from '@store/troubleshooting';

const allReducers = combineReducers({
  apiSettings,
  appNotifications,
  auth,
  conversionTool,
  countries,
  dashboard,
  dataFormats,
  entities,
  entityJurisdictions,
  filing,
  filingList,
  filingStatus,
  filingTypes,
  gameChanger,
  helpHero,
  inviteUser,
  jurisdictions,
  manageUsers,
  messages,
  notes,
  org,
  period,
  polishSku,
  reducedRates,
  registrations,
  savedFilingPeriod,
  standardTemplates,
  submission,
  taxCodes,
  transactionTypes,
  troubleshooting,
  upload,
  user,
  vatNumbers,
  vatReturn,
});

export default allReducers;
